import {createContext} from 'react';

export const initialState = {
  isReady: false,
  isAuthorized: false,
  userRole: undefined,
  userAccessRules: [],
  error: null
};

export const UserRoleContext = createContext(initialState);
